import { render } from "./ImageButton.vue?vue&type=template&id=6590e2b6"
import script from "./ImageButton.vue?vue&type=script&lang=js"
export * from "./ImageButton.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ricpp/Development/boldbrush/blog_post_editor/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__